module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "pn",
    attrs: {
      "id": "pt1"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("PART ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "pt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("ELIZABETH")])]), _vm._v(" "), _c('p', {
    staticClass: "ep-bot"
  }, [_vm._v("‘A flashing smile of appreciative delight’")]), _vm._v(" "), _c('p', {
    staticClass: "epc"
  }, [_vm._v("L"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ORD")]), _vm._v(" G"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ORELL")])]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_vm._v("E"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("LIZABETH")]), _vm._v(" A"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NGELA")]), _vm._v(" M"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ARGUERITE")]), _vm._v(" B"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("OWES")]), _vm._v(" L"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("YON")]), _vm._v(", born on 4 August 1900, was the ninth child of Lord and Lady Glamis, Claude and Cecilia. She was followed in 1902 by her brother David, to whom she became exceptionally close. Cecilia Glamis called these last two children ‘My two Benjamins’. They had eight siblings: Violet, born in 1882, was followed by Mary Frances (May), Patrick, John (Jock), Alexander (Alec), Fergus, Rose and Michael. (Violet died of diphtheria in 1893 at the age of eleven, just two weeks before the birth of Michael.) In 1904 Claude Glamis’s father, the thirteenth Earl of Strathmore and Kinghorne, died and he succeeded to the title.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Life for these children was as contented and secure as any childhood could be. In the first decade of the twentieth century, visitors to St Paul’s Walden Bury, their handsome Queen Anne house of rose-red brick in the fields of Hertfordshire, found a bustling, happy household, full of laughter, kindness and a wish to do good in the community.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Elizabeth’s first biographer, Cynthia Asquith, later wrote, ‘Its atmosphere of a happy English home recalls to one’s memory so many of the familiar delights of childhood – charades, schoolroom tea, homemade toffee, Christmas Eve, hide-and-seek. Nowhere in this well-worn house, one feels, can there ever have been very strict rules as to the shutting of doors, the wiping of boots, or the putting away of toys.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part1-1",
      "id": "par-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Throughout Elizabeth’s childhood, country-house life continued with little change. White tablecloths were still spread for tea on spacious lawns; field sports, especially shooting, were immensely popular among the aristocracy and their friends.")]), _vm._v(" "), _c('p', {
    staticClass: "txs"
  }, [_vm._v("Years later, in conversation with Eric Anderson, Queen Elizabeth remembered her childhood years:")]), _vm._v(" "), _c('p', {
    staticClass: "ex"
  }, [_vm._v("We were a very big family, you see. I had six brothers. I was nearly the youngest. It’s so nice being brought up by elder brothers. They kept a good eye you know. I was the youngest practically except for one little brother and so we were cherished and also disciplined, which is a very good thing. We all liked each other tremendously, I think. My very elder sister was at the very beginning of the family. She was a long way up. My middle sister was an absolute angel. Everybody loved her. In a way, my generation was very lucky – you feel very safe in a big family. It was a great thing to be loved."), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part1-2",
      "id": "par-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "stx"
  }, [_vm._v("Cecilia Strathmore was the greatest influence on the household. She was a woman of both gaiety and religious conviction who brought up her children in love of God, love of family and love of country. ‘Noblesse oblige’ may not have been a term she used, but Lady Strathmore certainly impressed on her children that they had been born very lucky and that their responsibility, indeed their duty (an important word to her), lay in being generous to others, especially those less fortunate. ‘Work is the rent you pay for life,’ she would tell her children.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Elizabeth was from infancy vivacious, loving the company of adults as well as of her siblings. One of her governesses later recalled that she had ‘a small dainty figure, a narrow, finely shaped rather pale little face, dark hair and lovely violet-blue eyes’."), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part1-3",
      "id": "par-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("An admirer, Lord Gorell,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn2",
      "id": "fn_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" later recalled that she had even as a child ‘that blend of kindliness and dignity that is the peculiar characteristic of her family. She was small for her age, responsive as a harp, wistful and appealing one moment, bright eyed and eager the next, with a flashing smile of appreciative delight.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part1-4",
      "id": "par-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her brothers were all sent to Eton, but Elizabeth was educated at home by governesses. After lessons, she and David would play together in the outbuildings around the house, and explore the vegetable garden. One governess observed, ‘Lady Elizabeth was adept at crawling under the netting and filling herself with strawberries while lying on her stomach.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part1-5",
      "id": "par-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("5")])]), _vm._v(" Elizabeth herself recalled the ‘absolute bliss’ of being in the stable surrounded by the smell of horses and leather, bits of which the groom allowed her to polish.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Every August, the family travelled to the Strathmores’ Scottish home, Glamis Castle. They would go up by train, with some of their servants, for the opening of the grouse season on 12 August. It was a great adventure for a child – Glamis was a thrilling place, with its tower, its turrets, its history and its myths.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The Castle was lit by hundreds of candles – electric light did not come until 1929 – and there were immense fires in many rooms. Two pipers marched around the table at the end of dinner, and then there were games or songs in the drawing room, led by Cecilia at the piano. Lord Gorell wrote later that the family was without any stiffness or formality. ‘It was all so friendly and kind … No wonder little Elizabeth came up to me once as my visit was nearing its end and demanded “But why don’t you beg to stay?”’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part1-6",
      "id": "par-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Both houses employed many of the local people. At Glamis, the Castle provided employment for inhabitants of the village near by; in Elizabeth’s memory all those who worked there – housemaids, kitchen maids, grooms – were friends of the family.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The new century into which Elizabeth was born was seen at the time as a moment of great optimism. Nineteenth-century industrialization had enriched Europe and North America as never before. Railways, steamships, motor cars and even bicycles had created an almost unprecedented revolution in transport. Aged ten, Elizabeth wrote an essay entitled ‘A recent invention, Aeroplanes’: ‘An aeroplane is usually shaped like a cigar, and has a propellor at one end, and on each side the great white wings, which makes it look like a bird [ … ] They are not quite safe, yet, and many, many axidents have happened.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part1-7",
      "id": "par-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Among her happiest childhood memories were the trips she made to Italy with her mother to visit her maternal grandmother in her various homes in Florence, San Remo and Bordighera."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn3",
      "id": "fn_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" Two affectionate letters to her father from Italy survive and one of them opens this collection.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("At Christmas 1909 she was given a diary and for a few weeks thereafter she kept it diligently – ‘Jan 1 1910 – I had my first nevew – great exitment.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part1-8",
      "id": "par-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("8")])]), _vm._v(" This was John, Master of Glamis, first son of her eldest brother Patrick, Lord Glamis, who had married Lady Dorothy Osborne, daughter of the Duke of Leeds, in 1908.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In July 1910, only weeks after the death of King Edward VII and the accession of his son, King George V, Elizabeth’s older sister May got married. By now Elizabeth had developed her happy letter-writing habit and wrote to May, ‘Darling May-Di-kin’, several times on her honeymoon. And whenever her mother was away, Elizabeth wrote her affectionate letters.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Elizabeth was dismayed when David was sent to preparatory school and then to Eton, but she wrote to him constantly. She remained at home whether in the country or at their rented house in London, in St James’s Square, with a succession of governesses, while making short forays to small schools including that of the Misses Birtwhistle in Sloane Street. She said later that she did not think she learned anything there – ‘A little bit of poetry I certainly remember. So I’m afraid I’m uneducated on the whole.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part1-9",
      "id": "par-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("9")])]), _vm._v(" In fact her school reports, preserved in the archive at Glamis, show her doing well in English, scripture and history, not so well in mathematics.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Probably the most effective governess was a young German woman, Käthe Kübler, who arrived in 1913. She was struck by Elizabeth’s love of her mother and their shared devotion to the Bible, which they read together every day. But she was shocked by how disorganized Elizabeth’s education had been. ‘With true German thoroughness I drew up a timetable for her lessons and a plan of study, both of which were approved by Lady Strathmore.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part1-10",
      "id": "par-10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("10")])]), _vm._v(" Fräulein Kübler’s work was brought to an end by the outbreak of war on Elizabeth’s fourteenth birthday, 4 August 1914. On that day, everyone’s world changed for ever.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Elizabeth’s brothers Patrick, Jock, Fergus and Michael all marched off at once to war, with hundreds of thousands of young men from all over Europe. Like many great country houses, Glamis and St Paul’s Walden Bury were converted into convalescent homes for wounded soldiers. Elizabeth was told by her mother that her task – her duty indeed – was to make the soldiers feel at home, visiting the wards, talking, running errands, playing cards with them. She did it all with grace and ease. One soldier said later, ‘She was always the same, asking, “How is your shoulder? Do you sleep well? Does it pain you? Why are you not smoking your pipe? Have you no tobacco? You must tell me if you haven’t and I’ll get some for you.” For her fifteen years she was very womanly, kind hearted and sympathetic.’ Everyone in the Castle ‘worshipped’ her."), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part1-11",
      "id": "par-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her closest companion throughout the war was Beryl Poignand, whom Lady Strathmore engaged as her governess and companion in November 1914. Thirteen years older than Elizabeth, Beryl became her best friend and co-conspirator, and Elizabeth’s extraordinary letters to her were full of the joy, excitement and fears of adolescence. Beryl ceased to be Elizabeth’s governess in 1917 but remained a close friend thereafter.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Like so many families, the Strathmores tasted tragedy in the First World War. Fergus, serving as an officer with the Black Watch, was killed at the Battle of Loos in September 1915. Elizabeth and her family, particularly her mother, were devastated. When her brother Michael was reported missing in 1917, the family went through more agony until he was discovered to have been taken prisoner, at which moment she wrote one of her typically exuberant letters to Beryl to declare that she was ‘!!MAD WITH JOY!!’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part1-12",
      "id": "par-12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her share of wartime suffering did not end with the Armistice of November 1918. Nine months later, one of her closest friends was killed in August 1919, fighting for the White Russian cause. She was inconsolable.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("By this time Elizabeth was no longer a carefree girl but a mature young woman. She was beautiful, charming, even coquettish, and attracted the attention of many young men. But there was much more to her. She had always displayed great sensitivity, and as a result of the sufferings of her own family and of the wider circle in which she had moved during the war, she had acquired an understanding of human problems, strengths and frailties which was to stand her in good stead in later life.")]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("10 February 1909 to Lord Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Poggio Ponente")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Bordighera")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Italy")]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("My darling Father, Thank you very much for the interesting letter you sent me. Yesterday I went down to the sea shore and enjoyed myself very much on the rocks. I could not go far because of the sea, it was lovly? Mother and Auntie Vava"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn4",
      "id": "fn_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" went to Florance on Sunday evening at 7 oclock. There is a dear little donky here called Marguarita and we put it in a little carrage and I drive it is so quiet have got nothing more to say exept it is a lovly garden my best love to yourself good by from your very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Xxxxxxxxxxxxx")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Oooooooooo")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Cecilia Strathmore’s mother, Mrs Harry Scott, spent a good deal of time in Florence and in Bordighera, on the Italian Riviera. Elizabeth and her mother made several visits there. When in England, she lived at Forbes House, Ham.")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: 1 January 1910")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("I had my first nevew great exitment. Same day went to Lady Littens Fancy dress party and had great fun. Jan 2 Sunday – did nothing went to church. Jan 3 lessons in the morning – in the afternoon I went to a party at Kings Walden there was a Xmas tree. Jan 4 had lessons in the morning. At 7 in the evning May, Rosie, David and I went to Lady Verhner in Fancy dress it was great fun, there were proggrams too and supper at half past nine. We went away at ten. It was from 7 to 12.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Elizabeth began her diary on 1 January 1910. Her handwriting was strong and even, but her interest in recording her life waned – as so often happens.")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("16 July 1910 to May Elphinstone")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("20 St James’s Square"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn5",
      "id": "fn_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("S.W.1")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Darling May-Di-kin,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("This letter will reach you just after the one I wrote last night, perhaps you will think it funny me writing so soon, but I have got such a lot more to ask and tell you, that I am writing before I forget it. Aslin has been a donkey, she has been looking in all your draws (I don’t mean what you wear) and was going to send you those fans (you know the ones you told me you were going to leav behind) and all sorts of things, but Mama told her not to touch a thing, except the trousseau dresses and things.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("David and I are going down to Ham in an hour for Sunday and on Tuesday we go to P.W. [St Paul’s Walden].")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("wasn’t it funny when they showered Sidney and you with rice,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn6",
      "id": "fn_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" how far did you go with the shoes fastened on the motor, the boys told Charles May to stand in front of them so you would not see.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Good bye Darling May")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("From your loving E.A.M.B.L.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS Please tell me if I am to call Sidney Darling or Dear.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘We always had cricket week at Glamis. A good many Eton people came and played … it was great fun, it really was. We played the neighbours, my father bowled. We played the Airlies")]), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn7",
      "id": "fn_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("from next door. Then there was a very good team called the Dundee Drapers.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn8",
      "id": "fn_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" "), _c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("It was easier then. People stayed in the house. I don’t suppose you could do that nowadays. What used to be so good was that lovely weekend in London at Lord’s in the old days when Eton played Harrow. That died didn’t it after the last war?’")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Sunday 20 November 1910 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Welwyn")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Darling Darling Lovie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am writing to tell you Alec"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn9",
      "id": "fn_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" is much much better. In fact he feels nearly quite well.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yesterday afternoon, Furgus made a big oven in the Yew Roundabout. We took down a frying pan, and roasted chesnuts and potatoes. Darling, Mother I do hope that the visit wasn’t "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" dull. Jockie got up early this morning and went to Holy Communion, he is going with Fergie and us again at 11. Everybody sends there love to You, Father, and Rosie. Please give mine too from your "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("very")]), _vm._v(" loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Tuesday 13 December 1910 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Darling Sweetie Lovie Mother")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope Alec is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("much")]), _vm._v(" better. "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Please please")]), _vm._v(" don’t worry "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("too")]), _vm._v(" much about him. We "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" miss you so! Hester Astly has got a party on the 17th of this month, it is a sort of meeting to explain the Childrens Union. If we are not to go please tell Lady Hastings. Outside your bedroom door here there is a long parcel which has the smell and touch of Umbrella’s! May is here and this afternoon we went into the wood with Ferges and her and we got some wild hyacinth bulbs in a place where they will not show. Poor Juno’s right leg is very lame! and her shouldour. I hope you won’t mind lovie, dovie but I took your rain umbrella to church with me on Sunday because it was raining so hard. [ … ] Miss Wilkie has not been here yet, but she sent me a letter to say what she would like David and me to do she said – essays, music, geografy, and sums. Good-bye darling lovie dovie from your "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS David’s love and May’s and Furges’s, my love to Alec, Father and Rose.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("16 December 1910 to Fenella Trefusis")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Dear Neva,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn10",
      "id": "fn_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("very")]), _vm._v(" very much for the "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("delicious")]), _vm._v(" box of chocolates. You did not put who it was from, but two or three day’s later Rosie wrote and told me it was you. Is’nt it awful perhaps we are going to have Xmas in London!!!! Think of it "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("Xmas")]), _vm._v(" in London. Yours was the first present I have recieved. It was most awfully kind of you to think of us. I have’nt the slitest notion of where you are staying so I am going to look in the Red Book. I am afraid you will hardly be able to read my writing as it is nearly tea-time and the lamps have not come yet. It has been raining and blowing for the last three days.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("David send’s his love and wants me to thank you for his chocolates.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Good-bye with much love from")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("17 February 1911 to Miss Ela Collins")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Miss Ela Collins"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn11",
      "id": "fn_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope you are feeling quite well. We are at St Pauls Walden, and it is a lovely day. This morning David and I got up at 6 o clock.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We first went and let out – Peter, Agiratem, Bumble-bee, Lionmouse, Beauty and Delicate, our six silver-blue Persian kitten-cats. After that we went to see the ponies, then we fed the chickens, there are over three hundred. Then we went to get Judy, Juno, her four puppies, and Major. Then we went to look for eggs for breakfast. After that we had breakfast, then went for a ride. After that lessons till lunch-time. Then lessons till half past four, then we took our tea into the wood and when we came home I began to write this letter. Good-bye Miss. Ela & with")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Love from")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth A. M. B. Lyon")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘I spent half my life in the stables when I was a child. And of course the groom was one’s best friend who allowed one to sit and polish bits of leather. Absolute bliss.’")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Wednesday 11 October 1911 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Carberry Tower")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Musselburgh")]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Darling Precious, I must just write a line to say goodnight and to tell you about the journey. Well about three miles from Perth we heard sssssssss, and we found a tyre had burst. Charles only took ten minutes putting on the other one, so we only just caught the train. We had a very nice journey, but it was very foggy when we got to Edinburgh. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Do give Rosie, Father and Alec my love, and a lot of kisses.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Good night darling precious lovie duck from your more than loving Elizabeth.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("26 December 1911 to the Hon. Clarence Bruce"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn12",
      "id": "fn_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear ‘Rotton Tomato’")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you very "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" much for the dee-licious peppermints. Its awfully kind of you to think of me. I hope you have had a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" happy Xmas, and I hope you will have a very nice New Year. You know in your letter you put ‘from the Green Tomato’. Well it isn’t ‘Green’ its ‘Rotton’. I haven’t forgotten you in the least. I am afraid I cant write you a very long letter, as I have got so many to write. I hope you are very well. Thank you again very much for the Peppermints.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Good-bye, Yours Affec Elizabeth Lyon")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS Please excuse my bad writing.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("[With two small drawings of heads, one scowling, the other smiling. Also a Christmas card signed ‘Elizabeth Lyon’, with a piece of dried heather inside.]")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Saturday 17 February 1912")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("At St Pauls Walden with Rosie, Father, David. Went out riding with Rosie from eleven o’ clock, till three o’ clock. "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("Great")]), _vm._v(" fun. "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("Lovely")]), _vm._v(" Day. Sunday Feb. 18 Went to Church with, Rosie, David & Father. Lovely day. Went for walk with R, D & F. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘St Paul’s and Glamis are both very much the same in one’s mind. We loved Glamis very much. Well, I think I stayed in them fifty fifty … St Paul’s is a dear old Queen Anne house – rather lovely gardens – and, of course, in those days very, very villagey. Before buses the villages focused on each other you know. It was very medieval in a way. We all adored my mother who really ran everything. My father, as people were in those days, was rather inclined not to take great part in running the family. He lived more of his own life.’")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: March 1912")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Wednesday")]), _vm._v(" Not at all well. Took some Gregory Powder."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn13",
      "id": "fn_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" Grannie and Auntie arrived in the afternoon was not allowed to see them in case I had influenzer. [ … ] Dr Thomas came."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn14",
      "id": "fn_14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" Felt quite well, a little tired. He said it was just a chill. So I came downstairs and saw Grannie. Michael arrived with his friend Lyonel Gibbs before lunch. They played tennis in afternoon. [ … ] Grannie gave me a little cup. Goodnight.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Friday 10 May 1912 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Darling Preacious Love")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope you had a good journey to Glamis (kiss kiss kiss). This morning Lady Kinnaird sent me a beautiful little snuff-box of "), _c('span', {
    staticClass: "epub-strike"
  }, [_vm._v("tortashell")]), _vm._v(" tortoisshell inlaid with mother-of-peal and gold. I think I have got a little chill today because my head is aching and I cant write properly. We read the bible this morning about Samson. We have got to do lessons in a minute so my writing will be very bad. David’s bycicle has come, I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("cant")]), _vm._v(" help envying him. It is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" hot today that its quite uncomfortable, one person in London has already died of the heat. I am missing you dreadfully lovie. Please give Darling Mickie a lot of love and say to him from me ‘Fie! Fie! who forgot the cigarettes’. I think it is the heat which has given me a headache because I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("have")]), _vm._v(" been to the "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Ahem")]), _vm._v(". Please give Darling Father my love too. I simply must fly to lessons, but I will write you a longer letter tomorrow.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("kiss.-kiss.-kiss.-kiss.-kiss.-kiss.-kiss.-kiss kisskisskisskisskiss for you. Ditto for Father & Mickie. Ditto trice for you lovie from your more than loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("XoXoXoXoXoXoXoXoXoX")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("19 September 1912 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Carberry Tower")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Preacious Love")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope you are having fun at Pauly. Is it nice weather. Yesterday here, it was gloriouse. We went to see Roslin Chapel."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn15",
      "id": "fn_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" I took some photographs of it.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I never in my life have seen such a beautiful thing the shape, the carving its too lovely. We also went to see some Prehistoricle caves, where Robert the Bruce is supposed to have hidden. I cannot remember the name of the place but I will tell you in my next letter Love. There are huge cliffs on each side of the river, running by the house, and they are finding new ones, and secret passages everywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The Baby, Sidney and May are very well. I am writing this in bed, before I go and see May to have a cup of tea. I hope you are very well Lovie, and are having lots of fun. I believe we are going to see Nina Balfour"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn16",
      "id": "fn_16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" this afternoon, it is about forty miles there.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Good-bye darling Preaciouse lovie duckie dodulums,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("from your very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘[My mother] would say, now darling you must look at these two houses, we were passing. One was ugly and one was beautiful in her eyes. So we had to learn. This is the beautiful one, you see, and bypass the ugly one.’")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl-ns"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("17 October 1912 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Glamis Castle")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Glamis")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("N.B."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn17",
      "id": "fn_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" Preasious LoveableLove")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope you had a very good journey. Please give every kind of message to David.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("And "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("do")]), _vm._v(" bring him up if you can. Lovie I was so sorry to have cried when you went away. I couldnt help it though. Love if you could get something for the dessert for our party do and put it down to Father. I am writing just as I am getting into bed, your train is just passing through Glamis Lovie darling.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Good night Love, I hope David is all right.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("David had started prep school at St Peter’s Court in Broadstairs, Kent, in September 1912. Elizabeth missed him greatly. Princes Henry and George, two of King George V’s younger sons, also attended this school.")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: 3–7 January 1913")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("January 1st")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Overeat myself.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thursday Jan 2nd")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Headache in the morning. very good tea. Christmas cake, Devonshire Cream, honey, jam, buns & tea. eat too much.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Friday Jan 3rd")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Not quite the thing today Breakfast very good. Sausages, kedgeree, Brown Bread, Scones & honey. Excellent lunch – beefsteak – 3 helps – ham and roley poley. I eat a good deal.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Sat Jan 4th")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am putting on weight. My waist measurement today 43 inches. Appetite good.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Sunday 5th")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Appetite still good, After healthy breakfast went to church. Came back very hungry for lunch. Roast beef, chicken, Yorkshire pudding, Plum pudding, cheese, cake & oranges. Oh, my poor tummy. Just going to have tea. Am "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very hungry")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Monday Jan 6th")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Quite an ordinary breakfast. No jam today! Rode Wonder in the morning & came in simply "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("ravenous")]), _vm._v(" for lunch. Omelette – two helps of roast chicken, finished up the bread sauce – five chocolate éclairs rium rium. Chocolate éclairs for tea – as no one else liked them, finished them up. Wish I was allowed more supper – always "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" hungry by the time I go to bed.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Tuesday Jan 7th")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Barrel of apples arrived today – had one for breakfast. 10 am eat an apple. 11 am had an apple for 11 oclock lunch. 12. had an apple. Roast pigeons and chocolate pudding & apples for lunch! 3 pm eat an apple. 3.15 pm David and I fought and have got bruise on my leg because he said I was greedy. eat two apples for supper."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn18",
      "id": "fn_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Tuesday 15 April 1913")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("At present we are at Poggio Ponente. This evening we are starting to Florence, Mother, Auntie, David & me, by the 7.30 from Bordighera. We are very busy packing. I have got 25 francs to spend, but I can always get some out of the Post Office Savings Bank if I see anything extra pretty. We are only staying till Friday evening.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Wednesday 16 April 1913")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("We have arrived in Florence at about 7 o’clock. We went straight to the Hotel Minerva. It is just next door to the Santa Maria Novella Church. Poor Mother was not feeling at all well, but she came with us all the same. First to the Duomo, then the Baptistry, the Singing Gallery, then we went and had lunch at 11.30 at a resterant. We also went to Cettepassi, and arranged about the pearls. I also bought an old cross, pearls & red stones, it was very pretty £6.0.0, but Mother paid half. In the afternoon we hired an open motor and drove right around Florence, up to Fiesole, where we saw the old roman remains and the Cathedral. It was lovely. 50 francs. In the evening Auntie & I did a little shopping.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Thursday 17 April 1913")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Mother was quite well that day. In the morning Mrs Jefferson took David & I to see St Marco’s Convent, where Savonorola was a long time, we saw a lot of Michael Angelo’s pictures. On the way back I bought 4 very pretty old cups & saucers. Then Mother, Auntie [Vava], D & I went to see Meacci,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn19",
      "id": "fn_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" Auntie gave us each a picture by him.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Very pretty ones, she also gave Mother a lovely one. Then we went back to lunch. Directly after we went to the Pitti Gallery, and then to Canta Gali, David & I each bought 3 plates, & Mother gave us each a pretty blue jar. Then Angelina took us to see Caponi, I love it. After that we met M & A at Jiacosa and had tea.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘When we were children both my grandmothers lived in Italy in the winter, and I just loved Italian things. I had a very clever Cavendish-Bentinck aunt, who took us to the Uffizi in Florence. She only allowed us to look at one picture … it was wonderful. Instead of poor little legs getting flabby with exhaustion, I remember looking at the Primavera. I can see it now. I suppose I was ten. I thought it was very clever of her really.’")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("18 July 1913 to David Bowes Lyon")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling David")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope you are very well. We have come down here for good now, at least till you come home. Fraulein"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn20",
      "id": "fn_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" goes to Germany on Tuesday 22nd next. Well, and ’ow are yer, Hay? Boo, you haint no good, you haint woggeling yer tooth. Oi ham. Dur. Whats the good o’ not woggeling. Hay? Aint no good at all. Arthur Duff has given me a new pony. Its 16 years old, but awfully good still. Only 11 more days now [until the summer holidays].")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("HOORAY,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("WHAT HO!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PIP, PIP.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Its a very short time. Everybody’s well. Do write me a letter soon.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Please do Ducky.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Goodbye your very very very very very very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Xxxxxxxxxoooooooo")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("30 November 1913 to David Bowes Lyon")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My darling David,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so much for your delightful pc. I’m afraid Ive been a dreadfull long time writing but Ive been "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("horribly")]), _vm._v(" busy, trying to knit Xmas presents and doing lessons.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Only 18 days to the holidays. 2 weeks and 4 days. It’s nice to think about. Mother got two enormous stockings the other day. I do look forward to us two opening them. I suppose next week you’ll write and wish Fergie a happy Christmas and a bright New Year. I really don’t know what to give him Its so awfully difficult to give a man something which he really likes, except guns and motors. Good thought. I might send him a motor. Shall we give it between us? Only a few hundreds! [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ta Ta young-feller-me-lad")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("From your respaactible E")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Friday 26 June 1914 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mother")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Most terrible goings-on here. At this present moment Fraulein is crying and sobbing in her room, and David is doing lessons with Mr Hewett. They had a dreadful quarrel just before tea, two at lunch, and I really "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("don’t")]), _vm._v(" know what to do. For the last week I haven’t had one single moment of peace, even in my room, and its "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("too")]), _vm._v(" awfull. I cant tell you how I look forward to Thursday, oh it will be nice. I really cant help just one tear now and then. But I do hope you will enjoy your weekend at Ham House, was Bisham fun? Only six more days! Hooray. We are going to tea with Freda Robertson tomorrow Saturday, and Gavin"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn21",
      "id": "fn_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" is going to take us out in his motor, one day. Everybody is very well, I don’t know about Fraulein, but I do pity her poor thing, and I’m afraid she’ll go away for good, with a bad feeling against this family, though I believe she quite likes me. I had such a nice letter from Mikie this morning, "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" funny, I’m going to wait till I’m cheerfull again to reply to him. Good-bye lovie, from your very very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Saturday 27 June 1914 to Michael Bowes Lyon")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mike")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you most awfully for your delightful episal. I was glad to get it, and it made me laugh some, you bet. I suppose you’r moving around pretty slick just now, dinner, balls ect. I hope you are having plenty of champenge, clarit, ’oc, mosel, and baeer, Baaeer, Baaeer, wonderful baaer, fill yourself right up to here (neck). That was by Shakespeare. Oi ad an horful noice toime yesterday playing ’opscotch with Fairweather,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn22",
      "id": "fn_22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" oi can taal you he got a talent for ’opscotch.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We are coming down on Thursday next, it will be nice seeing you all again. I’ts not very peaceful here! I am sorry to see by your picture that Spicer has’nt been shaving his nose lately, do tell him before I come down. Williams is playing the concertina most wonderfully, it’s really a delight to hear him, he attracts "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("crowds")]), _vm._v(" of people from all round. How’s old Rosie. I hope your health is good. Been to ‘Hullo Tango’ lately? I went to the Alhambra last night, jolly good show. Waal, good-bye Mike old gump, (Mike Gump) Ha Ha I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" call that funny. From your very loving and sweetly Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘The war broke out on my birthday. We went to the theatre and two people in the box were called up and one was a [young man called] William who had been in the Eton Eleven. I can’t remember who the other one was. The streets were full of people shouting, roaring, yelling their heads off – little thinking what was going to happen.’")]), _vm._v(" "), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Soon after this, Elizabeth went to see her brother Mike off at the station, on his way to war:")]), _vm._v(" "), _c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘There was a very young little officer going off, and his mother – I can see her now – was weeping. And I remember my brother leaning out of the train and saying “Don’t worry, I’ll look after him.” And do you know, he was killed the next day. It was so awful when one thinks about it.’")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("20 October 1914 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Miss Poignand"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn23",
      "id": "fn_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Mother wishes me to write and tell you our address in Herts:")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("St Pauls Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Welwyn")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Herts")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("She is very busy as we have just heard this morning that my brother Michael is starting for the front at any time, so I expect she will fly down South to say good-bye.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Please excuse my bad writing, as I’m in rather a hurry.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours sincerely")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth Lyon")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("9 August 1915 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Dear Miss Poignand")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you very very much indeed for your long and amusing letter, no news of you, comments on my letter, but all the same great fun talking or rather writing about our mutual friends. First I will try and answer one or two of your questions.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We sat in the stalls at the Hippodrome, right in the middle just under the gangway thing, so I got a lot of extra amusement, because you see the actors & actresses all walk along it.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("2) Yes, we did have rather an exciting journey up to Glamis, in this way. Two "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("most")]), _vm._v(" beautiful sailors were also travelling in the same corridor. [ … ] We had long conversations in the corridor in the morning, David and I were travelling alonio. Rather amusing, what?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("3) My hat is only a rotton little shiny rainproof one.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The soldiers are charming. My dear Miss Poignand you "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("are")]), _vm._v(" missing something! One is a fisherman and a Naval Reserve, he has been shipwrecked five times. Blue eyes, black hair, "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" nice. Reminds me of Henry."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn24",
      "id": "fn_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" By the way it’s getting awful. The vulgar and insulting telegrams on my birthday were about darling Henry’s stomach, was it real or a cushion, he was just having his 25th anniversary on the stage & such insults. Really it’s awful. Dear Beautiful One,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn25",
      "id": "fn_25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" I do so miss him, it was great luck, before I went, he had to pass right under the window so I had a good look at him, he really, honestly (bar rot) is very good looking and "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("clean.")]), _vm._v(" You know what I mean by clean, not like Fatty."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn26",
      "id": "fn_26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Wouldn’t it be wonderful if Fenella succeeded in getting a photograph of Henry, he would go first place on my dressing table. But I’m afraid he’s too modest to have any published. Father gave me a little horseshoe in pearls and diamonds for my birthday. [ … ] It’s very pretty stones, tho’ it would have been prettier "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("not")]), _vm._v(" a horseshoe.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I must end now, haven’t I written a lot of rot? Can you read my writing? David is yelling for me")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("au revoir, y l")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘Glamis became a sort of hospital and St Paul’s Walden was a hospital and we had ward jobs in the First World War, helping a bit in the hospital. Rosie did proper nursing and I only went and played cards with them in the evenings or perhaps wrote a letter or things like that. They all cheated like anything. It was all right – we played one of those games when you can cheat quite easily. There were about fifteen of them, mostly convalescent from the big hospital and I think they were really happy there. Then all my brothers went off. Everybody went. There was nobody left.’")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("26 August 1915 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Miss Poignand,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Perfectly wonderful, marvellous, absolutely indescribable news, prepare yourself---------.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Lavinia"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn27",
      "id": "fn_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" has a first cousin")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("who ------------—")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("KNOWS")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("darling")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("HENRY")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("VERY")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("WELL!!!!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("He is 35 (Hahahoo, Rosie and Mike will be squashed!) & she is going to write & find out the colour of his eyes, & everything, "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("also")]), _vm._v(" – get his signature. Isnt it absolutely unbelievable. Darling Henry. I am so pleased. I feel that it was quite worth sticking up for him all this time. Oh my sacred Aunt in pink tights, perhaps we shall even "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("meet")]), _vm._v(" him, help I shall die in a minute.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours, Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Friday Aug 27 1915. Spare neither time nor money in procuring a couple of photos of Basil Hallam."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn28",
      "id": "fn_28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("T’is of great importance.")]), _vm._v(" The news of Henry is wonderful. I really do not despair of "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("meeting")]), _vm._v(" or at least seeing him. Oh my sacred Aunt, you wait a few days. You just wait.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("From the usual person")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("31 August 1915 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Dear Miss Poignand")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I will now try to write you a letter with some news in it. (Not so much of the Darling.)")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Fergus"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn29",
      "id": "fn_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" has been home on leave, only 5 days. He went back on Saturday. Christian and the Baby are both here the baby is going to be called Rosemary.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I went to tea with Lady Jellicoe on Saturday last, she lives quite close. She had heard from Sir John who said he thought it wasn’t true about the Moltke"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn30",
      "id": "fn_30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" being sunk, that it was only damaged, but that he wasn’t yet sure.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Mademoiselle [Lachaise]"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn31",
      "id": "fn_31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" went away this morning. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Isn’t it quite too wonderful about Henry. "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("Please")]), _vm._v(" try and get some pictures of Basil. You know that postcard shop in Regent St we both hunted for? Well, I know where it has now moved to!! Please try there for Basil. Photograph preferred to a P.card. I enclose a plan of where it is. In Piccadilly, same side as Piccadilly Hotel. Nearly opposite St James’ Church. "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("The")]), _vm._v(" only place. If they don’t keep ’em they get ’em for you.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Goodbye Write soon,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours till the moon turns blue")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("14 September 1915 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Carberry Tower")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mother")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope you had a very good journey down, & also David. I miss you both "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("very")]), _vm._v(" much. I wonder if you could ask Catherine,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn32",
      "id": "fn_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" if she has time, to buy me some hair ribbon like the enclosed pattern as I have none at present? Darling Mother, don’t forget, a little white fox neck thing, a really chic hat, the ‘dernier cri’ in shirts, & a warm winter coat, the newest mode!!!!!! There is nothing much to say, as everything goes on just the same. I am feeling much better. I shall write to David. Please give him lots of kisses from me, and to you. Love to Jock & Neva from your very very very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("16 September 1915 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Carberry Tower")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Dear Miss Poignand")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Many thanks for your letters. I will first answer your questions. [ … ] Yes, the Zeppelins did a good deal of damage,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn33",
      "id": "fn_33",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" Wood St demolished as you say, and a Rubber Factory gutted, also, most of the casualties were from a bomb dropping on to a motor bus. They knew a whole day before that they were coming and yet made no preparations. I hear we have captured a German aeroplane & pilot at Wantage. That’s good. Its quite true. London is full of dreadful rumours. Dardanelles is going badly for us. But much the worst is that Kitchener is going to resign. [ … ] But, Sidney, who wrote about it, says that he does’nt think that this long suffering country would stand that, for they have such faith in K of K."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn34",
      "id": "fn_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" I hear the Russians are getting a much better supply of ammunition now, perhaps they will pick up a bit. I am going back to Glamis this afternoon, Oh,oh,oh, Miss Poignand old sport. How terribly you would have envied me. I spent the whole afternoon on the shores of the Forth. So near the ships that I could see people. And a conversation with a most beautiful sailor, with blue eyes and black lashes and "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" good looking. That was yesterday. He pointed out all the ships to me. First, nearest the bridge, came the Lion, then Tiger, New Zealand, H.M.A.S. Australia (to which he belonged), Indefatigable, Queen Mary and "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("many")]), _vm._v(" others. They looked too fine for words. I simply revelled in ’em. And simply hundreds of beautiful brown Lieutenants, Subs, Snotters [midshipmen], Admirals and sailors. Oh my. They were all most amorous! While I was watching the ships, they "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("all")]), _vm._v(" turned round, it looked "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" nice. Beatty’s fleet I suppose.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Love Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Sunday 26 December 1915 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Dear Silly Ass")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you very much for your letter. Always received with grateful thanks. I wonder if you have left London, anyhow I shall send this to Cheltenham.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Well, I hope you had a very happy Christmas, and nice presents. Would you like to know what I had?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Father gave me a wrist watch, Mother a kettle, Rosie some handkies, David some chocolates, Nurse a box with patience cards, Catherine a hankie, Auntie Vava a picture, Grannie a bowl, May a pair of shoe buckles etc in fact rather nice useful presents. I hope you liked the book. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The men liked the Tree very much I think, they each got an electric torch, a shirt & chocolate & crackers & things.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I believe the noise last night at ‘lights out’ was something appalling, trumpets & squeaky things going like mad etc. Abell said, ‘It’s a funny thing, I wanted a bloomin’ cigarette case, and I wanted a blinkin’ electric torch and I got ’em both’! So he ought to be quite pleased. Pegg asked me if you’d gone to Cheltenham. Ernest was simply delighted with his book. Of course we drank ‘To Hell with the b— Kaiser’ last night and good ’ealth to Henry and Larry!"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn35",
      "id": "fn_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" Nurse gets passionate love letters from Ralph & Co, also from one who signs himself ‘Prince William the Conqueror’. I think he must have got slightly mixed up! ’Ow h’are you my h’only h’adored one? Pretty bobbish??"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn36",
      "id": "fn_36",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Good-bye, farewell, fare ye well, Tarry not, so long, au revoir good bye farewell etc etc etc etc and so on for 2 pages.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("6 February 1916 to Mrs Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mrs Poignand"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn37",
      "id": "fn_37",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you very much for the delightful cutting about Mr Ainley and your letter. We have now got a huge box of cuttings, photographs and ‘poems’ all about him and we always welcome any addition to the collection! It must be delightful the spring flowers out, we have none up here yet, only Christmas roses and daisies. We all went into Dundee to the theatre there the other evening. Miss Poignand behaved herself in a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("disgraceful")]), _vm._v(" manner, she very nearly got chucked out by the ‘chucker out’! She sang "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so so")]), _vm._v(" loud that the manager came and asked her if she would kindly stop, whereupon, she sang "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("most")]), _vm._v(" aggressively to him (the poor man had a red nose) ‘Put a bit of powder on it’, which is a vulgar song. To crown all that, she drank "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("three")]), _vm._v(" cocktails on reaching home, and had to be carried up to bed by Barson,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn38",
      "id": "fn_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" who seemed to enjoy the job!!! I really felt quite ashamed of her! Thank you very much for your wishes about my exam. I don’t really think I shall pass, you see I don’t know much, and I’m most stupid. I think much the best plan would be for Miss Poignand to let her hair down, put on a short frock and do it for me. I should pass & get many distinctions! Don’t you [think]? Yes, she looked too funny for words on the pony, with her legs flapping, & her arms wagging about, I laughed till I nearly cried. But she stuck on all right, which was the chief thing! When we get to London she & me are going to have a gay time, we’re saving up for it. Thank you so much for your letter. Yours sincerely")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth Lyon")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("17 March 1916 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("20 St James’s Square")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mother")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Just a little letter to tell you the news from here.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I began my examination today."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn39",
      "id": "fn_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" I started soon after 8 this morning, and got to Hackney about 9.30! Bus and tram, it’s the only way. I did a ‘memory drawing’ paper, which ended 10.45, so I came back for lunch, & then went back again at 1.30! I did a ‘model drawing’ paper this afternoon and got home about 4.30. Altogether it took 4 hours on journeying from here to Hackney and back again! I’m what you might call ‘slightly fatigued’. The exam place is about the last house on that side of London, green fields beyond, stupid sort of place "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("I")]), _vm._v(" call it. My cold is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("much")]), _vm._v(" better, but staying in bed, even for only 2 days makes me feel ‘pale’ for a bit.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am going down to Eton tomorrow, to see David, May and Sidney are coming. I am taking him an Angel cake, six plums, & one lb of grapes, is that right? I hope that you are quite well Lovie, also Father, Rosie & Mike. I got a letter from Father this morning, what beastly weather you must be having, it’s fairly warm here just now. How are those horrible beastly, disgusting, food-gobbling, hideous, putrid, and above all "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("USELESS")]), _vm._v(" chickens? I have never seen such supercilious and snobbish birds in all my life. I am going to see "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("Henry")]), _vm._v(" next Friday when I’ve done my exam, you said I might, didn’t you? I am saying ‘Miserere’ "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("this")]), _vm._v(" Friday but "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("next")]), _vm._v(" Friday I shall say ‘jubilate’.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I’ve got to start at 8 tomorrow morning!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("So goodbye darling Mother from your very, very loving Elizabeth ooooooxxxxxxxxx")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("25 March 1916 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("20 St James’s Square")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mother Lovie,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very very")]), _vm._v(" much for your letter this morning. Yes, I am very happy to stay another week, and I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do so")]), _vm._v(" hope you won’t be lonely. I am going down to Slough with May this afternoon, to see her little house, with no roof, "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("or")]), _vm._v(" drains "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("or")]), _vm._v(" bath!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Then on to tea with David. I am staying the night with her. Lady Airlie"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn40",
      "id": "fn_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" got on the telephone this morning, and said ‘when are you coming to see me?’ And I’ve got to go to tea with her on Monday.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("am")]), _vm._v(" so dreadfully frightened. I can’t think why she asks me, it’s "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" kind of her but I wish she would’nt. I wish I’d suggested Tuesday, because then Rosie would have been there. [ … ] May is giving me a mauve linen dress by a French dressmaker who was with "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("PAQUIN")]), _vm._v(","), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn41",
      "id": "fn_41",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" aren’t I smart?!!!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I got a letter from Father, and he said that I didn’t tell him all the little bits of news that I told you, I didn’t think that they would interest him, being a man, but I will write him a really ‘chatty’ one now. I hope he is quite well. I am afraid I’ve failed in my exam, the Geography and Arithmetic were "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("quite")]), _vm._v(" hopeless, much too complicated for me! [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Goodbye darling Mother from yr very very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("28 March 1916 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("20 St James’s Square")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mother")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Rosie arrived all right this morning, though her train was rather late. We went out shopping together before lunch, she seems very well. We tea’d with May, and had to wait over an hour for a taxi! A terrific gale blowing, sheets of snow and altogether beastly weather. It must be disgusting at Glamis. [ … ] My tea went off fairly well with Lady Airlie!! Only she and Mabel"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn42",
      "id": "fn_42",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" were there. [ … ] Lavinia wants me to go to tea, to meet Princess Mary"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn43",
      "id": "fn_43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" and Prince Albert"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn44",
      "id": "fn_44",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" next Sunday. They don’t frighten me "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("quite")]), _vm._v(" as much as Queens. I do hope that Father’s cold is better. I sent Mike some papers today, and I’m bringing some songs with me too. Good bye darling Mother, don’t you think I’m very good at writing?! From your very very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("4 April 1916 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("20 St James’s Square")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mother")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope that you will get my telegram about David today. I wanted to go down and see him today, but he said that the doctor didn’t want him to see anybody for a day or two, and he was feeling ‘extraordinarily well’. Also he is leaving Eton Thursday or Friday, and, from his telegrams, sounded very cheerful, so I hope he’s not bad. Rosie is going down tomorrow. I can’t as I’ve got the dentist.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("My tea on Sunday with Lavinia was rather frightening – in fact, "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(". She had to get a few people to meet them, Princess Mary & Prince Albert I mean. The Duchess of Sutherland (young)"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn45",
      "id": "fn_45",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" was there, she’s rather pretty is’nt she? Moucha Cecil,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn46",
      "id": "fn_46",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("§")])]), _vm._v(" Lady Bury,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn47",
      "id": "fn_47",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("¶")])]), _vm._v(" Maud Cavendish,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn48",
      "id": "fn_48",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("|")])]), _vm._v(" all the Spencers also a Mr Penn,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn49",
      "id": "fn_49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("**")]), _vm._v(" who asked after Lady ‘Rosie’, a Mr Robinson who was very nice, & a Mr Dill.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I had a table all to myself at tea, with Mr Robinson on one side, & Mr Dill on the other, and I nearly "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("burst")]), _vm._v(" trying to think of something to say! Prince Albert was next door, he’s rather nice.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I was photographed yesterday. I am so afraid that you will be disappointed in them, the other photos there were all "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" hard but they’re coming tomorrow.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("May took me to the matinée this afternoon. Henry did a most weird and eerie sort of little play. The masks they wore were designed by Dulac,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn50",
      "id": "fn_50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" who hopped about in brown velveteen the whole time. Henry has got "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("the")]), _vm._v(" most "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("wonderful")]), _vm._v(" voice, and he was universally admired. He is so dreadfully shy, that it’s quite painful I believe. Thelma Cazalet"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn51",
      "id": "fn_51",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" said that they’de often asked him to lunch and that he was "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" shy that he’de accepted, and "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("always")]), _vm._v(" telegraphed an excuse, poor old Henry!!! I’m so glad as it shows that he is’nt a fast sort of man. There was a delightful orchestra conducted by Sir Thomas Beecham, who played some beautiful music. All the usual ‘matinee’ people were there. The "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("beeeeautiful")]), _vm._v(" siren, Lady Diana Manners,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn52",
      "id": "fn_52",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" Nancy Cunard (???!!!) Duchess of Rutland (white haggard face, red lips and ‘oh oh’ eyes!)"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn53",
      "id": "fn_53",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("§")])]), _vm._v(" Lady Lytton,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn54",
      "id": "fn_54",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("¶")])]), _vm._v(" quite pretty, Mrs Bonham Carter (otherwise Miss Asquith),"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn55",
      "id": "fn_55",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("|")])]), _vm._v(" a beautiful widow, unknown, fast, slightly painted, but undeniably good looking, "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("all")]), _vm._v(" the Duchesses, and the Dowager Duchesses, Queen Alexandra & family, & last but not least ME!!! "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("And")]), _vm._v(" of course dear Henry.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I suppose I’de better wait and come with David on Saturday night? Rosie dined with Marjorie Dalrymple Hamilton last night, Freddy was up for the evening."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn56",
      "id": "fn_56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" I lunched with May today. Two munitions men were there. The powder factory in Kent blew up, because somebody was walking about, smoking a cigarette, which was the stupidest thing that could possibly be done! Also the Zepps dropped 90 bombs round Waltham Abbey our biggest "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("cordite")]), _vm._v(" place, and killed – three chickens! Which was extraordinarily good luck. The damage done by the gale last week is frightful. They say it will be "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("quite three months")]), _vm._v(" before the train service is normal again, & every telegraph wire is down. Tell Father they’ll want poles. All ours come from Russia.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Well, darling Mother, I do hope that you are not "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" dull at Glamis. Rosie & I got a few dress stuffs at Harvey & Nichols, I hope you will like them.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Goodbye darling Mother from your very very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("19 April 1916 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Medusa"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn57",
      "id": "fn_57",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("[ … ] I shall have to start right now answering all your questions. Two records of Henry have arrived, ‘Sing, Belgians sing’. Mike said, ‘Yes, he "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("has")]), _vm._v(" got a beautiful voice’, which was a lot for him! Though of course it doesn’t sound so good on the gramophone. I shall fly to the Haymarket directly I get to London. We must try and go together, because we are about the only two people who "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("really")]), _vm._v(" appreciate the poor darling! Well, now I have got a bit of news for you. ROSIE is engaged to be married! Aren’t you surprised? to Wisp Leveson Gower! She got engaged last Friday! I know you always want to know everything so I will give you his full address: Commander the Hon William Spencer Leveson-Gower RN."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn58",
      "id": "fn_58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" He’s Lord Granville’s next brother. He’s been staying here the last few days, and he went down to London last night, and comes up again tomorrow for about 2 days. They wanted to be married in May, which is in less than three weeks, isn’t it awful. Though as he’s a sailor I hope she will be able to be a good deal with us, when Wisp’s at sea. He’s got a destroyer. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Barson is very well thank you, he’s "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("always")]), _vm._v(" well! The Nurse is coming May 2nd, and Mother is going to re-open May 3rd. "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("All")]), _vm._v(" our soldiers have now left Dundee. Tommy, the Sergeant, & Nicky have been discharged & gone. Pegg has been sent to a New Zealander’s hospital, where I expect he will be happier than in Dundee, & poor little MacGilhuddyreeks goes to a consumptive hospital. I don’t know about Freddy and Stevie, but I think they’ve all gone. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Well, I must stop now. I will send you one of the dreadful photos of me when they arrive.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Gott strafe Miss Jemima Goodman."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn59",
      "id": "fn_59",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" Gott strafe Hackney. Gott strafe Dalston Junction, Gott strafe the tapioca pudding (most especially), Gott strafe the whole exam, "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("but")]), _vm._v(" God bless Henry. God bless the shops with his photograph and all the nice things, we won’t strafe them. Shall we say ‘Gott strafe Medusa Poignand, the curse of the Poignands? "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("No")]), _vm._v(", we shall not. We shall say Gott "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("bless")]), _vm._v(" Medusa Poignand, the source of continued worry & anxiety to Elizabeth Lyon, who makes eyes at Fatty & conducts herself in a most unseemly manner.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours forever")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("26 April 1916 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("The Little House")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Clova")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Forfarshire")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Don’t for one moment imagine that Glamis is burnt or blown up, because it is’nt. We’ve only come up here for the day, to plant & tidy etc. It is the "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("first fine day")]), _vm._v(" that we’ve had since I came up from London, the weather has been hopeless. David & I are coming down next Monday if all’s well. He goes back to Eton on Wednesday, & I prophesy that Tuesday evening will be taken up. Most probably ‘Stand & Deliver.’")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Wisp thinks he won’t be in for a refit anyhow before May 10th, so the wedding can’t be fixed. Rosie & he go down tomorrow. She’s got to get her trousseau, & he joins his ship. I didn’t realise what a lot of things have to be got for a trousseau. I should "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("never")]), _vm._v(" be able to use "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("2")]), _vm._v(" dozen of everything, "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("lingerie")]), _vm._v(" I mean, good heavens, I’m thankful to say no. She and Wisp will be very poor. His destroyer is the Comet I think, & he is in the Grand Fleet up North. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("All that I say is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("DAMN THE EXAM!!")]), _vm._v(" I always was good at poetry wasn’t I?!! I’m not going to tell "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("anyone")]), _vm._v(" about it, anyhow till they ask me!! Good heavings! What "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("was")]), _vm._v(" the use of toiling to that er, place er Hackney? None, I tell you, none. It makes me "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("boil")]), _vm._v(" with rage to think of that vile stuff, tapioca, eaten for – nothing? [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Rosie will probably be married between the 16th & 26th, some time about then. [ … ] [She] gets all sorts of funny letters amongst her "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("hundreds")]), _vm._v(" of congratulations. Lord Curzon called her ‘an unplucked blossom’ [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("You remember that Friday (it’s always Friday) the last one I mean, after we’de been with Lavinia, & we had to go to tea with Mlle Lachaise?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We went by tube, & there were two old gentlemen sitting opposite, & they never took their eyes off me for "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("one")]), _vm._v(" second, it was "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" embarrassing. And a little foreigner who heard us speaking French in the lift followed us all the way, & sat next to us, & absolutely "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("dwelt")]), _vm._v(" on our words, he simply loved us, & was "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("dreadfully")]), _vm._v(" disappointed when we got out!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("To hell with all such people as the Oxford Examiners.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Good bye & behave yourself. A bientot Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘It’s a funny thing working for exams, it doesn’t last very long, does it? I remember working up a history bit or something. It’s awfully easy to forget. I think it’s easier to go round Windsor Castle and learn from that. There’s the whole of history there. From William the Conqueror and the stones coming up from Caen in Normandy.’")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("1 May 1916 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("20 St James’s Square")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("[Addressed to ‘Miss Medusa Pinpoint Poynard Poynment Poiggnand Poignand’")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("‘If "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("NOT")]), _vm._v(" away please do "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("NOT")]), _vm._v(" forward.’]")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I wrote you a most beautiful letter yesterday, and now I’ve had to tear it up & begin all over again, as I got one from you this morning! Zut! I mean Phut or Fut or Futte. We arrived yesterday morning from Glamis, quite safely, lots of sailors.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We left father and Barson sorrowfully drinking cocktails. It was 9 o’clock when we left & the sun was setting. I’ve never seen it look "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("quite")]), _vm._v(" so lovely. You see it sets right behind the hills now, & it was yellow & pink & gold, going gradually down to deeper & deeper blue, with a few huge yellow stars. Lordy how pretty it was. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Father comes on Tuesday, I expect he will spend his days in the Army & Navy Stores buying toothbrushes & sponges & campstools & such things! [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours till Henry is no longer our beloved")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("23 August 1916 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you many times for your charming & amusing letter. I am so glad that you are enjoying yourself at Ramsgate. Did you know I did "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("such")]), _vm._v(" a silly thing! Before I left London I wrote a long & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" good poem all about our adventures (very private) and then went and left it in the blotting book in the Morning Room! Fool that I am.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Mike left London for France yesterday. Damn. [ … ] Admiral Jellicoe"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn60",
      "id": "fn_60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" came over to tea last week. He’s too nice, "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" silly, just like a sailor! We went over to tea with him and his spouse last Friday, that is, Rosie & I. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Rosie went off yesterday to see Wisp. She will be about three weeks away. Mike went the day before, Rosie yesterday, my best soldier friend also yesterday, so I’m in a BAD temper! My ‘best boy’ being the Drummer boy as I don’t know any of them very well. I went & played ‘Donkey’ with them the night before last, at the end there was a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("wall")]), _vm._v(" of faces standing round and watching! Oh it "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("was")]), _vm._v(" embarrassing! One has the D.C.M. Most of the men won’t believe him, tho’ he has his ribbon. There are 15 men. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We are often getting Zeppelin scares, at least about 9 o’clock they telephone that the Zepps are here or coming, and by 11 all’s well. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Mother is better thank you.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Well, good bye, I don’t think it’s at "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("all")]), _vm._v(" proper you pushing soldiers about. I wish you’d met Ernest!! Well old thing "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("BE GOOD")]), _vm._v(" & luck pursue you.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("17 September 1916 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I don’t know whether you’ve heard anything about the fire yet? It’s a beastly nuisance. Yesterday, Saturday at 5.30, we saw smoke coming from the "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" top roofs. Nine soldiers & Sister had gone to the ‘pictures’, but the remaining 4 & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("all")]), _vm._v(" the maidservants rushed up and handed buckets like old Billy-o. The more water, the more smoke, we absolutely could "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("not")]), _vm._v(" find the fire. We then telephoned for the Forfar and Dundee fire brigades.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Before they arrived the little flames were sort of creeping through the roofs, you know – where the tiles are. It was too awful. Before 10 minutes the whole village was down! The former was absolutely "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("no")]), _vm._v(" use, having only a hand pump. The Dundee one heard at 6 o’clock, & was here in 26 minutes! Wonderful. They had powerful engines, and by midnight most of it was out. But the danger was great, & we "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("were")]), _vm._v(" so thankful when the water started. From 6.30 till about 10 o’c I stood just outside the drawing room door, sweeping down the water. The cistern upstairs had burst and the flooding was dreadful. Four soldiers who were harvesting on the farm helped very well, also people from the village. "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("All")]), _vm._v(" the furniture on the top two floors had to be carried down, & I had an awful job trying to find place. The drawing room was full, then King Malcolm’s Room, then your room (Mdlle’s) & the Strathmore Room! Only the very top rooms (where the empty turret is) were absolutely gutted, and the most awful amount of damage by water. It was pouring into the Drawing Room "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("all")]), _vm._v(" night, and the Chapel is a wreck. All the pictures with "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("huge")]), _vm._v(" smudges, it’s beastly. The Blue Room & Crypt were flooded, & the water didn’t stop till 5 this morning. Everybody was splendid, & my word I do ache!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("You see there was none of us indoors, and I had to direct every man bringing down the furniture, also it began to get dark, & I had to get candles. Mrs Stewart commanded everybody, & Mrs Swann was "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" flurried, just like a little partridge!! I can’t tell you all the little incidents, but it was "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("too")]), _vm._v(" dreadful, we thought the whole place would be burnt. Captain Weir, the Chief of the Dundee F.B said that if the fire had been today (a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("strong")]), _vm._v(" wind is blowing) nothing on earth would have saved the castle. I can’t tell you how unhappy we were, the flames were so awful. "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Half an hour after it started")]), _vm._v(", Lady Airlie telephoned to say would we come over if it got too bad, then Hughie Munro to ask us, then the Douglas’s telephoned, then the Fotheringhams, then Lady Dalhousie, all thought the Castle was burnt to the ground. The photographer, Dunn, (our old friend) was here last night, & presented me with postcards this morning. He took the charred remains today. I will send you one or two. Oh Lor, I’ve swept the big stairs the "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("whole")]), _vm._v(" morning, I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("am")]), _vm._v(" so tired.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours till the firemen leave (they like this place!)")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS Two firemen are staying. It broke out again this morning, and wants watching for a day or two.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("When the fire broke out Elizabeth’s father and brother David were shooting and many of the soldiers were at the pictures in Forfar. Elizabeth seized the initiative, calling the fire brigade and organizing the effort to save the pictures and other valuable contents of the Castle. The")]), _vm._v(" "), _c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Dundee Courier")]), _vm._v(" "), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("reported that she was ‘a veritable heroine’."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn61",
      "id": "fn_61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" Her mother wrote to Beryl, ‘Eliz’th was wonderful … Poor darling she was quite worn out after and ached all over for days.’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn62",
      "id": "fn_62",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("20 October 1916 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("so")]), _vm._v(" much for all your charming letters! I hope you are enjoying Richmond. Nothing doing up here. I go to the Ward every evening now. They are very nice. I wrote a ‘poem’ for dear Sergeant Little’s book"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn63",
      "id": "fn_63",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" yesterday. "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("All")]), _vm._v(" by myself. I did it when I woke up in the morning. Sister always teases him about his mental condition, because the poor man put a postal order in the fire by accident, and he does talk rather nonsense! Its rotten!")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("His mental state, said Sister")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Gives me quite a fright")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He talks such dreadful nonsense")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("Morning, noon and Night.")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("[ …]")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Though Sergeant Little’s brain is weak")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("His arm is very strong,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He strafes the Bosche like anything")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Here’s Luck to him life long!")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("They all thought it "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("too")]), _vm._v(" wonderful! They really thought I had brains! Also I was given the Queen of Spades "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("11")]), _vm._v(" times. I wondered what the terrific joy was about, & I found they’de been passing it under the table to give me! They are such babies! [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Good bye swine, write soon to Me")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘When the soldiers came to be nursed or convalesce, were they fun?’")]), _vm._v(" "), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("asked Eric Anderson.")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("She replied:")]), _vm._v(" "), _c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘Oh, yes. And one kept up an enormous correspondence when they went back, you know … one used to hear what was going on, you know. Oh no, they were absolutely splendid.’")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("25 October 1916 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Mr Dear Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Many thanks for your charming long letter. I was delighted to get it. I’m "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" sorry that you are cold, but you’ll be nice and warm when you die, which must be a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("great")]), _vm._v(" consolation to you.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I’m feeling sick already. Tomorrow they’ve got one of those – whist drives (pardon me oh), but really my feelings are a bit too much for me! I of course have got to present the prizes, and I shall "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("die")]), _vm._v(". "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("SIXTEEN")]), _vm._v(" huge men, "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("all")]), _vm._v(" the Hoggs and Stewarts and oh it’s "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("too")]), _vm._v(" awful. And not even you to hold my hand. Damn. Ten men go on Friday. I know them quite well now. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I wrote another poem and sent it back by Mother! It was to Harding, who delights in giving me the Queen of Spades! It goes thus – and is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("frightfully")]), _vm._v(" bad!")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I sometimes go into the Ward")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And play a game or two;")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And if I get the Queen of Spades")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Tis only due to you – Private Harding!")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("[ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Apparently he is delighted, and Sister said that he and Nix are very haughty now!!! Nix is angelic. I love him. You would too. He’s very small and merry with a golden heart as you might say. Did I tell you that Mother & I were solemnly photographed with all the soldiers?! By Mr Dunn? They all dressed up yesterday evening, and looked "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("too")]), _vm._v(" funny. The Glamis Band gave a selection! Twelve sit in a circle and one conducts. The gramaphone in the middle. The dinner horn is tooted, a bell is rung, the melodeon is squeaked, two penny whistles, a penny rattle rattled, a drum beaten, no tune at all, just only as much noise as they can possibly make! The noise is infernal! Poor Mrs Swann sits on a bed with an agonised expression on her face, stoping up her ears! Sister likes it! They are "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("quite")]), _vm._v(" mad. Harding was the Queen of Spades!! That was a great joke! Nix was ‘His Lordship’s Jockey’ and frightfully pleased with himself. I believe I’m going to be confirmed on 5th November, and we come South the 7th or the 9th. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Goodbye from yours I like whist drives")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("26 October 1916 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Just a line to tell you about the whist drive. I was "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("perfectly terrified")]), _vm._v(" all yesterday, but it wasn’t so bad as last time, somehow. The ‘Housekeepers Room’ people had got it up, and Catherine arranged it nearly all. [ … ] Wilson made a long speech, and then said that he wouldn’t keep them any longer as Lady Elizabeth had a long speech to make!! My face and jaw fell down to the ground with horror! However I didn’t! Harding got the 1st prize, 6 handkerchiefs, Pat Keeney an Irishman got 2nd, & McCleod got Booby. The two Booby prizes were a chocolate Nurse & a chocolate kiltie [a Highland soldier]. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Then, we danced! Rosie & I led off with Sergeant Robinson & Gordon. I with Gordon, who waltzed round & round "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("and")]), _vm._v(" round, till I nearly "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("died")]), _vm._v(", then thank the Lord his shoe came off, or else I should have fallen down with giddiness! [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ten of them went this morning, at eight o’clock. I’ve just waved them off from the Ward window. They were all dreadfully unhappy, and "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("too")]), _vm._v(" darling. They say they are all coming back in February.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The little Irishman wished me a merry Christmas & happy New Year!! Williams said ‘God bless you’ and they all said, thank you, very nicely. I do wonder if they caught their train! Because every two steps, they stopped, threw their kit bags into the air, and waved frantically, and of course "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("all")]), _vm._v(" the kit bags fell down, so "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("that")]), _vm._v(" took about 3 minutes to pick them all up. They all enjoyed themselves frightfully last night. No other news at all. [ … ] Well, I hope I shall see you in a couple of weeks. There is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("no")]), _vm._v(" excuse for you because there are "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("hundreds")]), _vm._v(" of trains to Richmond and it’s only sixpence. The little tiny funny Irishman said ‘You’ll get a letter from Ireland’. I don’t expect I will!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Good bye")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours till the moon turns blue")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("27 January 1917 [misdated 1916] to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Medusa,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I was so sorry not to see you last week but we were only there for the dancing & Wednesday, & left Thursday. David went on Wed. Will you come to a play with me soon? [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We might be coming to London in February, I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("hope")]), _vm._v(" so. Rosie is going to be painted by P de Laszlo"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn64",
      "id": "fn_64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" with the money that the tenants gave her for her wedding. She went to see him to arrange about sitting, and he simply went into raptures about her! He pulled down her hair, & did it up again quite differently, he bent her best hat and ruined it, and said she was exactly like Lady Hamilton you know, [George] Romney’s Lady H. "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Too")]), _vm._v(" funny.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Must fly goodbye. Oh, I had two letters from the front Nix and the Fish boy, both amusing.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours till the cows come home. E")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Thursday 3 May 1917 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Medusa,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Just a line to tell you we had a telegram this morning to say that Mike is missing on April 28th."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn65",
      "id": "fn_65",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" I don’t know what to say, you know how we love Mike, and it would be "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" terrible if he’s killed. It’s horrid & selfish of me to write you a miserable letter, but I’m so unhappy, & added to that I can’t help worrying about Mother in London. I thank the Lord that Rosie is there.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It’s dreadful, and somehow I never thought Mike could get killed. If he’s all right, he "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("must")]), _vm._v(" be, I’ll tell you. Your loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("6 May 1917 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("so")]), _vm._v(" much for your letter, it was such a nice letter. It’s so dreadful having to "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("wait")]), _vm._v(", I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" wish we could hear something. Somehow I never thought anything could happen to Mike, everybody is so fond of him, but one forgets that doesn’t count in a War, but you know I still have a hope that he is all right, because one simply "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("can’t")]), _vm._v(" tell, can one? I think you know, that Mike is the favourite of the whole family, Father’s very favourite son, & you know how Mother adores him, & Pat & Jock too, Rosie & me, everybody. It would be "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" dreadful if he was killed.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I’m going down [to London] tomorrow night. I’m afraid Mother is in a terrible state, & Pat you know is at St James’ Sq waiting for a [medical] board, & he is very bad too, I’m afraid. I’m "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("so")]), _vm._v(" sorry writing such a depressed letter, and "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("how")]), _vm._v(" I hope the next one will be mad & full of the usual rubbish.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("He said in his last letter you know, ‘If I’m pipped, I think little John"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn66",
      "id": "fn_66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" had better have my guns’, and so he knew they were going to have a bad time I suppose. I’ll tell you what Mother’s found out so far. "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("Ten")]), _vm._v(" officers of the 16th & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("many")]), _vm._v(" of the 15th are missing, and only "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("2")]), _vm._v(" in his battn are wounded, none killed so far. Sidney went to the W.O. [War Office] & found that out. Then May [Elphinstone] asked old Princess Christian"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn67",
      "id": "fn_67",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" if she’d write to the Crown Princess of Sweden who would find out quicker if he is a prisoner. Princess C "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("cabled")]), _vm._v(", so we ought to hear quite soon if he’s a prisoner of war. That’s all we could do. I’ll let you know the "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("very")]), _vm._v(" minute we hear anything, and thank you again for your letter so much.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Tuesday 22 May 1917 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("20 St James’s Square")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Ma Chere Medusa,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I’m quite and absolutely stark, staring, raving mad. Do you know why? Can’st thou e’en guess ? I don’t believe you can!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("AM I MAD WITH MISERY OR WITH JOY??")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("WITH")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("!! JOY !!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Mike is quite safe! Oh dear,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("nearly")]), _vm._v(", nearly burst this morning, We had a telephone message from Cox’s [Bank] to say they’d received a cheque from Mike this morning, so we "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("rushed")]), _vm._v(" round, and it was in his own handwriting, & they think he’s at Carlsruhe. Is’nt it "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("too")]), _vm._v(", "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("too")]), _vm._v(" heavenly. I can’t believe it, yes I can but you know what I mean, & how awful the last 3 weeks have been.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours madly, Elizabeth.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("9 October 1917 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so very much for your nice ‘scrappy’ letter. I was so glad to get it. How "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("exciting")]), _vm._v(" about your War Office job, I am "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" glad it’s near us, and I do hope you’ll like it. How beastly the air raids must be.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We’ve had "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("such")]), _vm._v(" an excitement here! The Forfar ‘boys’ came to tea last Thursday, and ours gave them a concert! I got back from Carberry on the Wednesday, & was met at Tay Bridge Station by Wright & Morris, the two "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("angelic")]), _vm._v(" & darling regulars. I do love them – you would too. Morris is a second Twinkley in a way. That evening we had the ‘dress rehearsal’ in the drawing room. Mother was accompanist, and the performers numbered 5. They came in at the door leading to the billiard room, & sang at that end of the room. Of course they were dressed up, & made up. It was "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("too")]), _vm._v(" priceless & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("really")]), _vm._v(" excellent. About a dozen songs, including a frightfully funny thing of ‘Annie Laurie’. They all five come on and sing Annie L. When they get to the middle, Wright goes wrong. ‘Hi stop, stop, you’re wrong.’ Then to Holley, ‘You’re out of it’. ‘’Oo? Me?’ ‘Yes, you’re out of it.’ ‘Alright, sing it yourself then’. And Holley departs. They start again. At the same place Wright goes wrong & the whole thing is done over again – till he is left alone to sing it. Then comes the "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("supreme")]), _vm._v(" joke of the concert!! He goes wrong again, and this time it’s "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Mother")]), _vm._v(" that’s ‘out of it’! "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Yells")]), _vm._v(" & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("roars")]), _vm._v(" of laughter. Mother also says – ‘sing it yourself then’ & goes ‘off’. He sings again, & has just got started when Morris comes ‘on’. ‘The stage manager wants to see you’ – & that’s the end of the song. My goodness, "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("what")]), _vm._v(" a success it was. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We sing every evening nearly, even "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("me")]), _vm._v(" too!!! Mother plays, & we go through "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("dozens")]), _vm._v(" of songs. Last night was Wright’s last night, he went this morning. We shall miss him "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("dreadfully")]), _vm._v(", he is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("too")]), _vm._v(" darling. When I was saying goodbye, he said ‘I’ll write’. So I remarked what a lot said that & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("didn’t")]), _vm._v(". So, "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" seriously he said, ‘I take an oath I will’. We are all great friends – it’s like old days! Waring has black eyes, ’ooo and they "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" glitter, it’s quite awful! I amused them most immensely yesterday evening, by singing ‘Wonderful Girl, Wonderful Boy, Wonderful Time’. I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("cannot")]), _vm._v(" make out the joke, I sang the ladies’ part, & they sang the man’s! I must find out what amused them so. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I must stop, as the post is going – people seem to think Peace is nearer now. I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" hope so.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Good bye my love, & keep safe from these air raids –")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours very coldly")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("(we’ve had snow here)")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Sunday 21 October 1917 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so very much for your delightful letter,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I was "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" pleased to get it. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Chapel was well attended this morning, and the hymns went very well. The men are very nice just now, only 10 of them. Yesterday afternoon, Sister, Waring & I went in to Dundee to the War Hospital to see Morris. It is a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("horrid")]), _vm._v(" place, dreary and smoky. We found Morris simply miserable. He had lost "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("6lb")]), _vm._v(" since leaving Glamis one week ago, and was looking dreadfully thin and ill. He was buried for 2 days & ½, his chest was crushed, and he can breathe only very badly. He is simply longing to get away. You see he’ll be discharged, (he’s had 13 years’ service, enlisted at 14) & so Mother has written to Major Young. Everybody likes Morris,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn68",
      "id": "fn_68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" he’s "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" nice, and very upright & honest. He quite depressed us! We took him eggs, butter etc. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("There is a terrific gale blowing today. There is nothing thrilling to tell you. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("26 November 1917 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("[ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Just back from a nerve racking and terrible experience – bidding good-bye to "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("FOURTEEN")]), _vm._v(" men! It really makes me weep & a lump in my throat. I can’t bear it ever. And there is such a nice dear Sergeant whom I took a violent affection to yesterday evening, he is so nice tho’ dreadfully ugly. I begged Sister to push him downstairs or give him a blister or something. I wish I didn’t take violent affections too late – it’s "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("always")]), _vm._v(" the day before they go!!! I always have to say goodbye after dinner now, because firstly they go at 7 A.M. and secondly Sister likes to show me off in evening dress, because they never have seen evening dresses which embarrasses me "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("too")]), _vm._v(" dreadfully. They invariably look at my shoes, except the ones that gaze rapturously into my eyes sighing deeply all the while, which are "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("nil")]), _vm._v(", nowadays that I have my hair up etc!! Some of them are charming, but oh! the difference from Dec. 1914! I was just remembering this evening, that night when Mr Brookes, Harold Ward, Teddy, David (in pyjamas) & I had a bun fight in the crypt, and David chased Nurse A round the Ward with cocoa & water to pour, & how it all got spilt on the floor, & her black fury!! It "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("was")]), _vm._v(" fun – weren’t they darlings? I have been thinking so much between these lines that it is now 10.15 & I must go to bed. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It’s so dreadful saying goodbye, because one knows that one will never see them again, and I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("hate")]), _vm._v(" doing it. Do you remember our goodbyes on the doorstep, & waving them all the way up the Avenue? [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We shall come down next week I expect, I’ll let you know the date later. Goodbye from your loving but at the moment depressed –")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("[ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘I remember quite well thinking when I was seventeen I could never be happy again. I mean everybody was unhappy. Because one knew so many people. Every day somebody was killed, you see. It was a real holocaust. It was horrible. I remember that feeling quite well.’")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("5 January 1918 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Chere Medusie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("How "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("splendid")]), _vm._v(" about your brother’s promotion. I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("am")]), _vm._v(" glad, thousands of congratters. He’s very young isn’t he? I expect you are deeeeeelighted, m’sure. Poor overworked thing.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("You must come here for a Sunday soon to recuperate. The apple house is overflowing (at the moment), so there will be "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("something")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Mother, David & I went up to London for the night on Tuesday, but I hadn’t a moment to ring you up. It was a terrible rush. On the way from the station, we were dropped at the dressmaker, & I tried on my dress. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The next day, D & I were "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("slightly")]), _vm._v(" en retard for breakfast! Then I rushed & had my hair washed (!) (ze leetle naturrral currrls) & rushed all over London trying to get some shoes to go with my dress. Swallowed some lunch, & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("just")]), _vm._v(" caught the 1.35!! I was a white haired wreck on reaching here. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Oh by the way, I had a lecture the other day from Mother & David! That I ought to be more flirtatious! I nearly died of surprise. You know I daresay I’ve got rather quiet from having all those Australians & NZ (!!!) at Glamis, as one simply "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("must")]), _vm._v(" sit on them! Wasn’t it funny? And the worst of it was, Major Metcalfe came here yesterday, & I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("absolutely forgot")]), _vm._v(" to try the ’appy ’optic on him!! It would have been such a chance! Never mind, Captain Jebb is coming this evening to stay, tho’ I know I shall be just as mouse like when he’s here!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("did")]), _vm._v(" laugh. Ha Ha.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("What I remember of Mr Parker"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn69",
      "id": "fn_69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" was one evening at dinner, he asked me if my birthday was between August 1st & 10th or some such dates. I said ‘yes’, & he then remarked mysteriously ‘ah, that accounts for it’. I asked him what he meant, but he refused to disclose the dread secret! However, next morning I made him tell me, and apparently he’d read some book in N.Z., about stars, & dates & calculations & things, "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("you")]), _vm._v(" know the sort of book. It put all the ways of finding things, & apparently he’d worked out that ‘THE’ person for him’s birthday had to be some time between August 1st & 10th!!! Somehow, you calculated between the two birthdays. I laughed, couldn’t help it.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Well, I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("hope")]), _vm._v(" he’s found a charming gurrrrl in N.Z.! That’s the best thing for him. His Father was an Englishman. Everybody liked Mr Parker, I did too, & David did, which was a good thing. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am coming up on Monday, as my dance is on Tuesday (ugh), so if you get this in time, "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" come in, if you can get off after tea, & have supper with me. I shall be alone as Mother isn’t coming till Tuesday. So "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("do")]), _vm._v(" if you can on Monday. I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("expect")]), _vm._v(" I shall come up in the morning, so "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("do")]), _vm._v(" ring up if you have a moment, & perhaps you could come to lunch "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("too")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Must fly,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("V loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("9 January 1918 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am writing in my bedroom to tell you about the dance, & also why I didn’t ring you up this morning. Well, I trembled all yesterday afternoon! I arrived at Lady Dorothy Wood where I was dining for the dance at about 8.15. The ladies there were – Sybil Scott (Buccleuch), Vere Smith, Margaret Sutton (whose dance it was), a ‘Wood’ girl & Lady Dorothy.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The men consisted of Mr Wood (our host),"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn70",
      "id": "fn_70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" Mr Johnson, Archie Balfour, Count de Grünne & Lord Halifax. I sat between Lord Halifax & Lord St Audries who didn’t turn up. The dance was quite close, & we arrived at a little before 10. Michael Biddulph (Adèle’s"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn71",
      "id": "fn_71",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" brother) was there & I danced with him, Archie, Mr Johnson, a Mr Phillips, Mr Brocklehurst, Mr Ogilvy"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn72",
      "id": "fn_72",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" & last but not least little Willy de Grünne."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn73",
      "id": "fn_73",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("§")])]), _vm._v(" He dances "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("too")]), _vm._v(" divinely, & is at the Embassy. I danced every single dance, & Mother came to fetch me, & we departed at about 1.30. [ … ] I enjoyed it "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" much. One could only dance with such few people tho’ because the dances were "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" long, but I loved it, and enjoyed it fearfully. Do you know I think my dress really looked quite pretty. [ … ] I saw Lavinia at the dance, but she had an ugly dress on, & wasn’t looking half as nice as I’ve seen her look, I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("was")]), _vm._v(" so sorry. And Delia"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn74",
      "id": "fn_74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" looked "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" old, but perhaps she was bored or something.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Oh! When I arrived here yesterday what do you think I found? A letter from –! Yes it was! Mr Parker! He had left England about the middle of November, & so he must have sent that story thing off himself. His letter was dated Nov 29th. He said he had not been able to get off before. The two other New Zealanders who had been at Glamis, were also on board with him, rather curious, wasn’t it? So he must have arrived in N.Z. by now. Ought I to thank him for his letter? Oh dear! it’s so muddling! I expect we shall come up next week, but I’ll let you know.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very loving & perplexed")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("7 February 1918 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("20 St James’s Square")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Where are you? Why do you hide away? Why don’t you ring up? Don’t be shy dearie, nobody’s looking & ’ere’s the mistletoe.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Oh dear I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("am")]), _vm._v(" so worried. You remember I told you that we were having a tiny dance tonight, sort of to ask back people who’d asked me etc? Well, "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("millions")]), _vm._v(" of people have proposed themselves & it’s "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("grown")]), _vm._v(" and "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("grown")]), _vm._v(", & nearly "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("everybody")]), _vm._v(" is coming. I really had no idea that the Strathmore family was so popular, it’s awful. And really, people "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" propose themselves rather too much I think. Well, I’m so mixed up. I can’t write but I’ll tell you all about it later. Lavinia is coming. I’ll show you the sort of thing that happened. Mother asked Delia to bring a very few people, & she is bringing "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("ten")]), _vm._v(", lots of people are doing that, so it mounts up "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("dreadfully")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Such")]), _vm._v(" a funny thing happened!! You remember the little Lieut I told you about? (Naval of course.) Well, he rang me up on the phone last night, & we had a I-don’t-know-how-to-describe-it talk. Poor little man, I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("was")]), _vm._v(" sorry for him. You know I’ve got a soft spot in my ’eart for a bhoy in blue, so ’ave you and he was so pathetic! I’ll tell you about it, if it would amuse you, when I see you. And I’ve written four pages to Mr Parker, but I simply "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("can’t")]), _vm._v(" get the last bit in! I wish I could talk to him, it’s so difficult writing, & I know it will just miss him in New Zealand! If you get this tomorrow "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" ring up – I "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("might")]), _vm._v(" be here.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("These young men "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("do")]), _vm._v(" worry me so, I "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("wish")]), _vm._v(" they wouldn’t. Do come round & give me some more of your sage (?) advice!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("David is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" run down & weak, & it will be quite a long time before he goes back to Eton I expect. Dr Thomas examined me ’eart, & said it was enlarged!! I laughed! Couldn’t help it! It sounds "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" funny, doesn’t it? Anyhow I’m not to do much, & I suppose I oughtn’t really to dance! Must stop, I’m all trembly inside me, oh oh – "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" ring up if you can. Yours full heartedly (!!) Elizabeth.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I haven’t seen you for years – "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("do")]), _vm._v(" come.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS Mother wants me to ask you this. She has promised to have a small dance for Overseas Officers next Tuesday from 8–12!! Can you come? We could put you up for the k-night. You simply "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("must")]), _vm._v(", it would be such fun. You really must come, & if you have a friend – a young nice-looking one mind, send her along too. If you know anybody who could get home at night I mean. None of these "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("fast")]), _vm._v(" people, my dear Medusa who are corrupting your poor mind, but anyhow "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("you")]), _vm._v(" must come – Pip Pip!!")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Wednesday 13 March 1918 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("20 St James’s Square")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear old thing")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("so")]), _vm._v(" for your amiable letter, ah, what joy! What "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("palps")]), _vm._v(" the mere sight of that wonderful handwriting gives me! Etc etc.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Well, Mother & I came up yesterday, and Mother went back to St Paul’s Walden this morning, & I am going this afternoon. The reason we are going back, is, that it is Father’s birthday tomorrow, & we must be there for at least a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("portion")]), _vm._v(" of it! We are coming up again tomorrow afternoon, as Lady Portarlington’s dance is in the evening, and I shall probably stay here till Monday. We went to Lady Hastings’ dance last night, it was quite fun. [ … ] Katie was there,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn75",
      "id": "fn_75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" looking supremely bored, till I took her up to the top of the house, & we giggled foolishly for a few minutes, then she cheered up!! We got home just before two.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The darling [Elphinstone] children came to tea yesterday. Elizabeth has lost her front teeth, otherwise they are just the same. They "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("were")]), _vm._v(" so darling. I called Elizabeth ‘Toothy’ at tea, whereupon they all burst into yells of laughter, & food was sputtered all over the place! They’ve got extraordinary senses of humour, and see jokes in the most harmless things! I am going down to Pauly with them this afternoon. I foresee a riotous journey. ‘Let’s draw’. ‘Draw me a cow Peter’."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn76",
      "id": "fn_76",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" ‘No Peter, draw me a bow wow’. "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("You")]), _vm._v(" know! I am writing in bed which is horribly lazy isn’t it. It’s 11.30 so I must get up.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("12.30 Just as I wrote that Catherine came up to say that Lieut. Hamilton was here. I tumbled out of bed, and was dressed in "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("10 minutes")]), _vm._v(". I always like seeing Freddy, he cheers one up so much, because he really is ridiculous! He’s just gone, as he’s only passing through London on his way to Dover, where he is joining a new ship called the ‘Murray’.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am going to lunch with May so I must ’urry. When shall I see you? "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Do")]), _vm._v(" ring up. I shall be here by tea time tomorrow probably. There is very little to tell you really, so I will now draw to a close hoping this finds you as it leaves me at present in the Pink. (Pretty good, that.)")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I shall be late for lunch!!")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Friday 22 March 1918 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I don’t know "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("why")]), _vm._v(" I start writing letters to you at this hour! I am in bed, & feeling tired after 2 late nights, but not sleepy! I had great fun last night at the Harcourts’. Rather a terrifying dinner first, in which I sat between the Prince of Wales"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn77",
      "id": "fn_77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" & Count Michael Torby."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn78",
      "id": "fn_78",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" It was very nice tho’. As usual I danced the first dance with P.W., I don’t know why, but I usually do! I danced three with him, & several with my faithful friend, Victor Cochrane Baillie."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn79",
      "id": "fn_79",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" He is very nice, but extremely ugly poor thing. Also Gerard Brassey,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn80",
      "id": "fn_80",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("§")])]), _vm._v(" who is very nice, & all my old friends. It was the last dance for some time, so tho’ I enjoyed it very much, I felt slightly depressed at moments. Such a lot of these boys are going out quite soon – in fact nearly everybody I know. I suppose they expect fearful casualties. They are "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" young, a great many only nineteen. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Good night and "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" write soon, and cheer me up for losing my young men. I do hope your brother was well. Your loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("23 March 1918 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mother")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do hope you had a good journey up to Glamis, & arrived alright. It "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("was")]), _vm._v(" a bore having to go off & I am "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" looking forward to your return. I expect you won’t be back till Wednesday.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I got down here alright yesterday and found the children staying awake for me. Father is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" well, & so far has eaten quite well. I feel very flourishing, tho’ a tiny bit tired, & have been out all the afternoon. It has been "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" hot, I couldn’t wear a coat or gloves or flannel petticoat or anything warm! It is too delicious for words.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I enjoyed Lady Harcourt’s dance "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" much, tho’ I felt a little depressed, because it was the last dance, & I expect nearly everyone I know will be gone by the next one. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Please remember me to Sister and the Ralstons & everybody. I am longing for you to come back Mother darling.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I must stop as it’s post time. Good-bye darling Mother, from your very very")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("20 April 1918 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("[ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We’ve just come back from Devonshire. It was deliciously warm there, and very pretty. The cliffs are such a wonderful red colour there, and "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("you’d")]), _vm._v(" adore it because of the bathing! [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I won’t write about the War – It’s too awful. I heard from Nina Balfour yesterday, that Lord Settrington"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn81",
      "id": "fn_81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" is reported wounded & missing. I am so sorry, he is so nice, & I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("hope")]), _vm._v(" he’ll turn up alright. So very many are missing now aren’t they? It was snowing hard last night but it’s warmer today! I wonder if Peace will "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("ever")]), _vm._v(" come. I feel as if I never want to go to a dance again, one only makes friends & then they are killed. Don’t you feel depressed lately! But the news is better now, I hear that Foch"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn82",
      "id": "fn_82",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" is quite pleased. I do hope you’ll enjoy yourself frightfully. V loving E")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS Please forgive a deadly dull letter but I am cold, and depressed! Do write soon old thing. The children leave on Monday.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("26 May 1918 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Dutch House")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Dovercourt")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("4 o’clock")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Here is my promised letter. I am still waiting for yours! It is great fun here, tho’ we did nothing till yesterday when we dined with Wisp. My first visit to a warship of any kind at all! We have just come back from lunching & will be shortly returning to dine!!! Well, I’ll tell you all about it. You see we didn’t go before as he was boiler cleaning. We take the train out to Parkeston (5 minutes) and there his motor launch meets us and we go alongside the ‘Scott’."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn83",
      "id": "fn_83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" Then there is a ‘wavy ladder’ (thank the Lord there are ropes each side) and when you get to the top a couple of sailors who salute, and one feels foolish and doesn’t know if one ought to bow low and return their salutation! Then one falls heavily down the hatch (is it?) into the waiting arms of a Sub or (preferably) a Lieut! Wisp’s cabins are most luxurious & beautifully fitted, as of course it is one of the very newest ships. He has his meals in lonely splendour, the Ward room is opposite. He’s got three pipers & they always play during meals which is very nice. I haven’t seen over the ship yet, but hope to soon. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The station master (Syme) at Glamis’ son is still with Wisp. He is a very good looking man, and excellent I believe. He bursts in at meals with Signals, he is Yeoman of Signals. The Sub also yells things in & says ‘Aye Aye Sir’ & altogether it’s fearfully nautical!!! Mess traps. Hatch somethings. Port holes. Cocktails. Aft – Forrard! Etc Etc. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Thursday 13 June 1918 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("20 St James’s Square")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("You "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("were")]), _vm._v(" a swine in St James’ St yesterday. You made me blush like anything! I knew what you were thinking – two couples walking out one behind the other!! We went and had lunch with Freddy at the Berkeley, a very riotous one I assure you! But it was great fun. In the evening I dined with Lord and Lady Powis, a huge dinner party and we danced afterwards till about 1 o’clock. I had several dances with a little American"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn84",
      "id": "fn_84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" from the Embassy with such nice eyes. He was so funny and asked me to come to the play with him. I said ‘wouldn’t that be fun’ and he’s coming to tea next week! Oh Lor I’ve gone and been and done it now! [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Lord Erskine would insist on walking home with me, and whenever I danced with the American he looked furious and whenever I danced with him the American was angry! It was awful. ‘Oh Gawd’ as the private soldier said when he was doing Macduff. I have suddenly taken to blushing again. I do hope it will go soon, it’s such a bore. Oh dear, do write and let me know how you are enjoying yourself, you know I haven’t seen you "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("properly")]), _vm._v(" for some time now – I don’t count our midnight conversation last week! Have a very good time. V loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("10pm Saturday 21 September 1918 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Thank God – it’s all over! I’ve made my speech, and now there are only the hymns to play in Chapel tomorrow, & I shall be at peace. I’ve really had an awful time these last few days – things "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("invariably")]), _vm._v(" crop up when Mother goes away, and I’ve had "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("such")]), _vm._v(" a lot to decide. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I had this sale in Forfar today! I was so sick and frightened and can’t remember anything about it except that I managed to get through my speech without a mistake! Adèle and I were greeted by Mr Tubey, then Adèle, Eupham Douglas & I went up on to the platform with a clergyman on each side of us!!! I was presented with a bouquet! ’Orrible. I am so glad it’s over I feel weak and dithery this evening in consequence! [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Pip Pip! I feel so tired, must stop. Goodbye old darling do behave. Very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("[ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘I was brought up like that: “Well darling, it’s your duty” and saying to one’s mother “I can’t”. But you know that, aged seventeen, you’ve got to go and open the flower show: “It’s your duty, darling.”’")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Tuesday 1 October 1918 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Many many thanks for your letter – I was beginning to wonder what had happened to you if you’d eloped with —— or some such ’orrible affair! You must be very very hard worked, I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" wish you could come up here for a holiday. It "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("would")]), _vm._v(" be so heavenly! [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Very nice men in the hospital now. We sing in the evenings a certain amount – they love it. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Bulgarian news is good isn’t it? I do hope Turkey will be reasonable. What about Peace next Spring?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Goodbye old thing, do write when you can, as I shall feel so lonely. R & Wisp also going today, oh why can’t you come?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS We had Holy Communion on Sunday, & 4 soldiers came & Sister. I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" wish you could have painted a picture of them kneeling before the Altar, in their hospital blue with Sister. It really was a beautiful sight, tho’ it gave me a lump in my throat. I keep on thinking of it. Poor dear boys, it was "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" pathetic somehow. You can’t imagine quite I daresay, but it would have made a heavenly picture. The white & silver Altar, & the blue suits with Sister’s white apron & cap etc.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("22 October 1918 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Many many thanks indeed for thy charming letter – I am so glad you are having a nice quiet rest at Westgate – it will do you a lot of good.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I was just thinking how sad it would have been if I’d never met you! You are my best friend and adviser now – worse luck pour vous! I am writing at 11.30 p.m. and ought to be in bed. I’m in my dressing gown anyway and all ready for bed. The two Aussies are very nice. Mr Williamson is good-looking & very nice; Mr Rohan is tall, fat and merry and also nice. We have great jokes and they are always saying the most complimentary things to me which I take as a terrific joke; so we are great friends. Mr W is really a dear, I am very fond of him – poor boy, he has got a very badly smashed foot and has been very ill. I give them quinine twice a day and feed them up, so I am called ‘Nurse’.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yesterday we all drove into Forfar in the wagonette (Rosie is still here) and did lots of shopping. I went with Mr Williamson to try to get a pair of shoes, but he couldn’t get one anywhere near on. I’m afraid he was dreadfully disappointed.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Well – on Saturday I got quite a good post – two letters and a parcel from France, and one from an Australian!! A very long and really quite interesting letter from my little Canadian,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn85",
      "id": "fn_85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" with an iron cross in the parcel. I am so pleased with it – one from Victor Cochrane Baillie – he is coming on leave at the end of the month, and wonders whether I shall be in London – which I shall not. And some photos from this Aussie who had been staying with the Ralstons. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yes – what shall we do about Ernest?"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn86",
      "id": "fn_86",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" It must be over 6 months since we heard. Do you think he can be killed or anything? I cannot understand his not writing.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Here is the post coming – I hear Barson and a crackle of papers arriving? What for me? Nothing? [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Well, there isn’t much to tell you, I must go and give my little boys their quinine and they will say some silly things!! I do wish you were here.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Good byeee old darling,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("from your very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("At eleven o’clock in the morning of 11 November 1918, the Armistice was signed and the war ended. Elizabeth was at Glamis and years later would recall the soldiers from the Castle marching happily together to the pub.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘They went straight to the village to celebrate and I think they drank too much. Seats got broken up to make a bonfire and all that sort of thing. I can see them now, all going to enjoy this wonderful moment.’")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("27 November 1918 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("20 St James’s Square")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Thweet Medutha")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ithn’t it thad? I’ve developed a lithp. Do you like lithpth? [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Mr Williamson, Mr Rohan & a friend of theirs came to tea with me today. They were very nice & so silly, & we yelled songs round the piano after tea. I did so hope you would come in, why didn’t you? I would have liked you to have seen them.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I feel depressed now. Can’t "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("think")]), _vm._v(" why. No reason on earth. Everything is wonderful. "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("So")]), _vm._v(" long waiting for Mike perhaps – see only 241 officers have arrived in a fortnight. "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Do")]), _vm._v(" ring up; Mr W has such a funny soft voice. Mr R just as fat & nice & jolly as ever.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS Let’s go to a play. Find out what’s good pleeeeese.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("5 January 1919 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I was so dreadfully sorry to fly off and leave you in that rude fashion on Friday! We simply dashed off to the station and arrived just as a train full of repatriated prisoners got in. However, [Mike] wasn’t there and we watched five trains in and at last he came at about 7 o’clock. We waited with such amusing people from Kennington and Whitechapel!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Mike is fairly well and cheerful, it is so delicious having him. He and David are playing billiards at the moment and I am rushing between the gramophone and this here letter! Mike brought a friend with him to stay on Friday, a man called Lathom. He looked very ill and absolutely dazed. He merely sat and looked at the fire. Tho’ he certainly looked much better after a good night’s rest. Poor boys, they must have had a beastly time, they hate talking about it. It was so pathetic at the station, you ought to go and watch a special in from Ripon. Personally I rather loved ‘The man from Toronto’. Did you? Do ring me up as we are coming up tomorrow for two days – must stop. Goodbye darling old thing.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("The Armistice had been greeted with joy across Britain but by the spring of 1919 the country was struggling with the enormity of the sacrifices that had been demanded of it. Three-quarters of a million British people had been killed. At the end of the war millions of people around the world were out of work and at least twenty million are thought to have been killed by the Spanish flu epidemic. Economic output had collapsed. Discontent grew and the siren calls of revolution were heard (and sometimes accepted) across Europe.")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Saturday undated [22 March 1919] to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("20 St James’s Square")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest M")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Many "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("many")]), _vm._v(" thanks for your note. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I went with Adèle & her mother today to see the Guards"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn87",
      "id": "fn_87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" from the Equitable Insurance Office, in front of the Mansion House, & we saw beautifully. I was so amused recognising all my partners looking so comic & stiff!! You see they had to give ‘Eyeeeeees – right’ for the Lord Mayor. But the awful thing was not a soul cheered. There were millions & millions of people absolutely silent. "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Dreadful")]), _vm._v(" feeling. I longed to say ‘Cheer – damn you’ or words to that effect – it was ghastly. But they always get a wonderful reception in the West End, so that might make up. The only time they cheered was for the Prince of Wales, and at the "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" end of the procession a Black Maria rumbled along. You should have heard the roars of laughter & cheers – Oh the Cockney sense of humour! They simply doubled up with mirth! After 2 hours of silence this really tickled them! It was too funny going home! We had an electric brougham, & they thought we were some kind of Royalty, & I bowed smilingly, & it "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("was")]), _vm._v(" fun. (New hat.) And going across Berkeley Square we passed three American officers, I bowed beautifully to them with my best smile, & they saluted! To change the subject. Alas! The letter is from a far far worse person than Mr Reynolds or Mr Parker! Do guess. I never had such a shock in my life when I got it. It began by my Christian name & ‘please forgive but what the heart feels, the tongue must speak or the hand write!!’ Darling I loff you – will you be mine – sort of idea – isn’t it orful? When shall I see you? Soon, pleeeeese "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Sunday night undated [6 April 1919] to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("20 St James’s Square")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("How goes life with you? The usual beginning! I haven’t seen you for ages – at least it seems like ages to me – I haven’t written that letter to Mr Bagshawe"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn88",
      "id": "fn_88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" – ‘My dear Vivian, thank you a thousand times – I’ll come by the next boat – till then! Thine E.’ – do you think that would do? Ha Ha!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Well, last night I gave a play party! We dined at the Ritz & went to ‘Joybells’ – George Robey"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn89",
      "id": "fn_89",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("too")]), _vm._v(" priceless. We must go – It was Neva, Emma Thynne & me, Mike, Captain Keenan & Charlie Settrington. I am writing in bed and am beginning to be sleepy. As a matter of fact I have taken a lot of exercise today! I went out for a joy ride with Charles – (as above). We went down to Walton & had lunch – then went to Box Hill, & went for a long walk – it was a delicious day, quite hot, & there is a most "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("glorious")]), _vm._v(" view for miles & miles. Then we tootled along, & had tea at an extraordinary place, where the waiter winked, & said he "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("also")]), _vm._v(" came from London! Then we went back to London, & I had a second tea with Katie. He’s a dear is Chawles, & honestly, just a friend. One’s family always thinks a man must be violently in love with one, which is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" annoying if one is friends. Because there is nothing more pleasant than being friends, & the whole enjoyment would go at once, wouldn’t it, if anything flirtatious came into it? It’s a funny thing, but quite true!!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("If you have nothing to do one Sunday or Sat – I should go down there, & climb Box Hill – the view is worth it. I should think the bus would go to Dorking for that. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Goodbye old darling and do write soon, from your loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘You weren’t supposed to go out actually without somebody. I was never allowed to go to a ball unless I went to dinner with somebody, you know, first. An eye was kept. As for being asked out to lunch by a young gentleman, absolutely impossible. Funny how things have changed …")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘But of course it made it frightfully exciting. I remember once creeping out of the house in St James’s Square round the corner into Duke Street and going off to lunch with a very nice young gentleman in one of those horrible little low cars. You know, you whizzed off and had lunch at some pub down Portsmouth Road, came back again. You know you felt so wicked. We were so innocent.’")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Thursday 17 April 1919 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so very much for your letter which I was more than pleased to receive – ah!! It’s really simply years since I last saw you – I don’t count Althorp, that was merely a glimpse. Wasn’t it awful? I do hate weddings! I was so annoyed at being drawn into conversation just when I was talking to you and when I came down again you’d gone. And with you all the sunshine (Colonial touch). Little Elizabeth [Elphinstone] is here and I had to chide her! She said to me – ‘Peter I know I am going to enjoy myself – Peter, I’m enjoying myself like the "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("devil")]), _vm._v("’. So I said, ‘darling you must not say such things’, ‘but Papa says it "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("always")]), _vm._v("’ she said. What can you say? She is such a darling.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("No – no more drives to Box Hill with Chawles – he probably loathes me by now, people usually do when they get to know me! But it was great fun, & he’s really very nice.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I’ve got a very sore arm from being inoculated! It’s all swollen up and looks ’orrid.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I haven’t answered Baggy yet. Isn’t it awful? Oh dear!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("How are you old darling? Very well I hope. I simply can’t write as Mike, Jock & David are having a comic argument in Hertfordshire! Forgive dull letter. Goodbye old darling.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Sunday undated [31 August 1919] to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest M")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you a thousand times for your angelic letter. I have been very unhappy over poor Charlie"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn90",
      "id": "fn_90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" – he is my only "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("real")]), _vm._v(" friend, & one feels one can never have another like him. He was a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("real")]), _vm._v(" friend, I wasn’t shy of him, and he was "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" delightful. It’s a dreadful thing, and his family simply "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("adored")]), _vm._v(" him. He was quite unique, and always said what he thought, and altogether it’s terrible. I think I must have been fonder of him than I realized, because now there seems a kind of a blank – if you understand what I mean? Captain Glasses, Bruces etc are nothing, Charlie was the only one I could just talk naturally to – he was a darling, and I miss him very much. I liked him specially because he "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("never")]), _vm._v(" tried to flirt, or make love or anything like that – which always spoils friendships. Even that day we spent down at Box Hill. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you again a thousand times for your letter, Very loving Elizabeth")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02826ec8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part1.vue
// module id = 78
// module chunks = 0